<div class="sunburst-content">
    <ng-container>
        <h4 *ngIf="isDetailsVisible">{{ showedLabel }}</h4>
        <h4 *ngIf="!isDetailsVisible">{{rootNode.text?.shortLabel}}</h4>
    </ng-container>

    <div class="sunburst" #sunburst>
        <ng-container *ngIf="rootNode">
            <div *ngIf="isDetailsVisible" class="part-details">
                <div class="part-percent">{{ showedPercent }}</div>
                <div *ngIf="rootNode.isAmount" class="part-value">{{ showedValue | formatAmount: 'auto' }}</div>
                <div *ngIf="!rootNode.isAmount" class="part-value">{{ showedValue }}</div>
            </div>
            <div *ngIf="!isDetailsVisible" class="part-general">
                <div *ngIf="rootNode.isAmount" class="part-value">{{ rootNode.amount | formatAmount: 'auto' }}</div>
                <div *ngIf="!rootNode.isAmount" class="part-value">{{ rootNode.amount }}</div>
            </div>
        </ng-container>
    </div>
</div>
